import { dehydrate } from "@tanstack/react-query";
import { GetServerSidePropsContext } from "next";
import TrackRacesContainer from "@/components/container/HorseRacing/TrackRacesContainer";
import termsList from "@/constants/hr-terminology.json";
import { GetTrackRacesQuery } from "@/graphql/gql/graphql";
import { TermsT } from "@/types/horseRacing";
import { getRandomLearningTerms } from "@/utils/horseRacing";
import { loadHeader, loadRaceByTrack, loadTrackRaces } from "@/utils/ssr";

interface TrackDetailProps {
  trackCode: string;
  raceNumber: number;
  tab?: 1 | 2;
  initialTerms: TermsT;
}

const TrackRacesPage = ({
  trackCode,
  raceNumber,
  tab,
  initialTerms,
}: TrackDetailProps) => (
  <TrackRacesContainer
    raceNumber={raceNumber}
    trackCode={trackCode}
    tab={tab}
    initialTerms={initialTerms}
  />
);

export async function getServerSideProps({
  query,
  params,
}: GetServerSidePropsContext<{ track: string[] }>) {
  if (params?.track) {
    const [trackCode] = params.track;
    const { race, tab: tabParam } = query;
    const maybeRaceNumber = Number.parseInt(race?.toString() ?? "", 10);
    const menuClient = await loadHeader();
    const trackClient = await loadTrackRaces(menuClient, trackCode);

    const [queryKeyData] = trackClient.getQueriesData({
      queryKey: ["track races", trackCode],
    });
    const trackData: GetTrackRacesQuery =
      queryKeyData?.[1] as GetTrackRacesQuery;
    const races = trackData?.HR_Track?.races;
    const fallbackRaceNumber = Number.parseInt(races?.[0]?.number ?? "", 10);
    const raceNumber = Number.isNaN(maybeRaceNumber)
      ? fallbackRaceNumber
      : maybeRaceNumber;

    const racesClient = await loadRaceByTrack(
      menuClient,
      trackCode,
      raceNumber
    );
    const tab = tabParam === "2" ? 2 : null;
    const initialTerms = getRandomLearningTerms(termsList.terminology, 3);
    return {
      props: {
        dehydratedState: dehydrate(racesClient),
        sportSlug: "horse-racing",
        trackCode,
        raceNumber,
        tab,
        initialTerms,
      },
    };
  }
  return {
    notFound: true,
  };
}

export default TrackRacesPage;
